import { removeElementIndexedDB } from "../functions";

var ModalWarningRemovePhoto = {
    view: function (ctrl, args) {

        return m('div.dm-overlay',
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span", "Удаление фото"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: ModalContainerWarningRemovePhoto.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                                    m("div[style='text-align: center;']", [
                                        m("b[id='titleModalRemovePhoto']", args.data)
                                    ]),
                                    m("br"),
                                    m(".row[style='text-align: center;']", [
                                        m(".col-xs-6", [
                                            m("button.btn.btn-success.btn-lg", {
                                                id: "yesBtnModalRemovePhoto",
                                            }, "Да")
                                        ]),
                                        m(".col-xs-6", [
                                            m("button.btn.btn-danger.btn-lg", {
                                                id: "",
                                                onclick: function () {
                                                    ModalContainerWarningRemovePhoto.close();
                                                }
                                            }, "Нет")
                                        ])
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        );
    }
};

export var ModalContainerWarningRemovePhoto = {
    container: null,
    idElement: null,
    removeAll: null,
    removeDB: null,
    init: function () {
        ModalContainerWarningRemovePhoto.container = document.querySelector('#modalWarningRemovePhoto');
        if (!ModalContainerWarningRemovePhoto.container) {
            ModalContainerWarningRemovePhoto.container = document.createElement('div');
            ModalContainerWarningRemovePhoto.container.id = 'modalWarningRemovePhoto';
            ModalContainerWarningRemovePhoto.container.hidden = true;
            document.body.appendChild(ModalContainerWarningRemovePhoto.container);

            m.mount(ModalContainerWarningRemovePhoto.container, m.component(ModalWarningRemovePhoto, {data:  "", type: false, idElement: ""}));
        }
    },
    open: function (title, removeAll, removeDB, idElement) {
        ModalContainerWarningRemovePhoto.container = document.querySelector('#modalWarningRemovePhoto');
        if(typeof(idElement) != "undefined" && idElement !== null)
            ModalContainerWarningRemovePhoto.idElement = idElement;
        if(typeof(removeAll) != "undefined" && removeAll !== null)
            ModalContainerWarningRemovePhoto.removeAll = removeAll;

        if (ModalContainerWarningRemovePhoto.container) {
            document.getElementById("titleModalRemovePhoto").innerText = title;
            document.getElementById("yesBtnModalRemovePhoto").addEventListener("click", function () {
                if(ModalContainerWarningRemovePhoto.removeAll) {
                    localStorage.setItem("unsavedPhoto", []);
                    var conteiner = document.getElementById("pictureConteiner");
                    conteiner.innerHTML = "";
                }
                else {
                    if(removeDB) {
                        var idParent = ModalContainerWarningRemovePhoto.idElement;
                        removeElementIndexedDB(idParent);
                        m.request({
                            method: 'PUT',
                            url: '/api/task/' + m.route.param('taskId') + '/removePhoto',
                            data: ModalContainerWarningRemovePhoto.idElement
                        }).then(function (response) {
                            var idParent = ModalContainerWarningRemovePhoto.idElement;
                            removeElementIndexedDB(idParent);
                        }, function () {
                        });
                    }
                    else {
                        var idParent = ModalContainerWarningRemovePhoto.idElement;
                        removeElementIndexedDB(idParent);
                    }
                }
                ModalContainerWarningRemovePhoto.close();
            });
            ModalContainerWarningRemovePhoto.container.hidden = false;
        }
    },
    close: function () {
        ModalContainerWarningRemovePhoto.container.hidden = true;
    }
};
